var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "download", on: { click: _vm.click } },
    [
      _vm._v(" " + _vm._s(_vm.label) + " "),
      _c("w-spacer"),
      _c("w-fa", { attrs: { icon: "download" } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }